import React from 'react';
import { makeStyles } from '@material-ui/core';
import { designTokens } from '../../../styles/designTokens';

const useStyles = makeStyles({
  container: {
    marginBottom: designTokens.spacing.sm,
  },
  text: {
    ...designTokens.typography.label,
    color: designTokens.colors.black,
    marginBottom: designTokens.spacing.xs,
    margin: 0,
  },
  progressBar: {
    width: '100%',
    height: '10px',
    backgroundColor: designTokens.colors.grey[100],
    borderRadius: '5px',
    overflow: 'hidden',
    position: 'relative',
  },
  segment: {
    position: 'absolute',
    left: 0,
    top: 0,
    height: '100%',
    transition: 'width 0.3s ease',
    borderRadius: '5px',
  },
  greenSegment: {
    backgroundColor: designTokens.colors.green.main,
    zIndex: 3,
  },
  yellowSegment: {
    backgroundColor: designTokens.colors.yellow.main,
    zIndex: 2,
  },
  redSegment: {
    backgroundColor: designTokens.colors.red.main,
    zIndex: 1,
  }
});

const LoadIndicator = ({ load }) => {
  const classes = useStyles();

  const greenWidth = Math.min(load, 49);
  const yellowWidth = load > 49 ? Math.min(load, 74) : 0;
  const redWidth = load > 75 ? load : 0;

  return (
    <div className={classes.container}>
      <p className={classes.text}>{load}% Завантаження відділення</p>
      <div className={classes.progressBar}>
        {redWidth > 0 && (
          <div
            className={`${classes.segment} ${classes.redSegment}`}
            style={{ width: `${redWidth}%` }}
          />
        )}
        {yellowWidth > 0 && (
          <div
            className={`${classes.segment} ${classes.yellowSegment}`}
            style={{ width: `${yellowWidth}%` }}
          />
        )}
        {greenWidth > 0 && (
          <div
            className={`${classes.segment} ${classes.greenSegment}`}
            style={{ width: `${greenWidth}%` }}
          />
        )}
      </div>
    </div>
  );
};

export default LoadIndicator;
